import { render, staticRenderFns } from "./ReservasCoordinadasComponent.vue?vue&type=template&id=6e0c68b6&"
import script from "./ReservasCoordinadasComponent.vue?vue&type=script&lang=js&"
export * from "./ReservasCoordinadasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports